import { useEffect } from 'react';

const overlaySelector = '.modal-backdrop, .drawer-backdrop, [role="dialog"]';
const fieldSelector = [
  'input:not([type="hidden"]):not([type="file"]):not([disabled])',
  'textarea:not([disabled])',
  'select:not([disabled])'
].join(',');

function focusFirstField(root: Element) {
  window.requestAnimationFrame(() => {
    const field = root.querySelector<HTMLElement>(fieldSelector);
    field?.focus({ preventScroll: true });
    if (field instanceof HTMLInputElement && field.type === 'text') field.select();
  });
}

export function AutoFocusManager() {
  useEffect(() => {
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          const overlay = node.matches(overlaySelector)
            ? node
            : node.querySelector(overlaySelector);
          if (overlay) focusFirstField(overlay);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  return null;
}
